// =============================================================================
// Theme Presets - Metadata & Configuration
// =============================================================================

export type ThemePresetId = 'classic' | 'midnight'

export interface ThemePresetMeta {
  id: ThemePresetId
  name: string
  description: string
  preview: {
    sidebar: string
    accent: string
    surface: string
  }
}

export const THEME_PRESETS: ThemePresetMeta[] = [
  {
    id: 'midnight',
    name: 'Midnight',
    description: 'Vibrant purple with dark sidebar',
    preview: { sidebar: '#271938', accent: '#d8b4fe', surface: '#4c1d95' },
  },
  {
    id: 'classic',
    name: 'Classic',
    description: 'Clean and minimal light theme',
    preview: { sidebar: '#ffffff', accent: '#7F22FE', surface: '#f9fafb' },
  },
]

export const DEFAULT_PRESET: ThemePresetId = 'midnight'
export const COOKIE_NAME = 'app-theme-preset'

export function isValidPreset(id: unknown): id is ThemePresetId {
  return THEME_PRESETS.some((p) => p.id === id)
}
